import { message as toaster } from 'antd';
import { isEmpty } from 'lodash';
import qs from 'qs';
import { store } from 'store';
import { hideLoader, showLoader } from 'store/appSlice';
import { redirectToLogin } from 'api/authentication';
import { isModalAvailable } from 'components/common/webBlockNotice';
import axios from './api.config';

class ApiRequestClass {
	constructor() {
		if (ApiRequestClass._instance) {
			return ApiRequestClass._instance;
		}
		ApiRequestClass._instance = this;
	}

	/**
	 *
	 * @param {string} url
	 * @param {object} data
	 * @param {boolean} showLoader
	 * @param {string} method - must be a lowercase, it's axios get, post, delete, patch methods
	 * @param {object} queryParams
	 */
	async common({
		url,
		data = {},
		showLoading = true,
		method = 'get',
		queryParams = {},
		setErrors = undefined,
	}) {
		if (showLoading) {
			this.handleShowLoader();
		}

		try {
			const URL = this.addQueryParamsWithUrl(url, queryParams);
			const response = await axios[method](URL, data);

			return Promise.resolve(response.data);
		} catch (error) {
			this.handleErrors(error, setErrors);

			return Promise.reject(error);
		} finally {
			this.handleHideLoader();
		}
	}

	addQueryParamsWithUrl(url, queryParams) {
		Object.keys(queryParams).forEach(
			(key) => queryParams[key] === null && delete queryParams[key]
		);

		return url + qs.stringify(queryParams, { addQueryPrefix: true });
	}

	handleErrors(error, setErrors) {
		if (error) {
			try {
				const { data } = error.response;
				const { status } = error.response;
				const checkNetworkError = JSON.stringify(error);
				const NetworkError = 'Network Error';

				if (checkNetworkError.includes(NetworkError)) {
					toaster.error(NetworkError);

					return false;
				}
				if (status === 500) {
					console.log('error', error);
					toaster.error(data?.message || error.message);
				} else if (status === 401) {
					this.handle401Error(data);
				} else if (status === 422) {
					/**
					 * 422 error is form validation error
					 */
					this.handle422Error(data, setErrors);
				} else {
					this.handleCommonErrors(data, status);
				}
			} catch (e) {
				if (error.toString().includes('timeout')) {
					toaster.error('API Timeout');
				} else {
					toaster.error('Something went wrong please try again');
					console.log('Unhandled error', e);
				}
			}
		}

		return null;
	}

	handle401Error(data) {
		/**
		 * 401 is authentication error like session failure
		 */
		redirectToLogin();

		if (
			data?.error === 'Failed to authenticate token.' ||
			data?.error === 'Auth token is invalid or expired.'
		) {
			toaster.error('Login expired, Please Login');
			redirectToLogin();

			setTimeout(() => {}, 3000);
		} else if (data?.error) {
			toaster.error(data?.error);
		}
	}

	handleCommonErrors(data, status) {
		// Modal already covers the screen — skip duplicate 403 toast.
		if (status === 403 && isModalAvailable()) {
			return;
		}
		let error = '404 - Resource Not Found';

		if (data.error) {
			error = data.error;
		} else if (data.message) {
			error = data.message;
		}
		toaster.error(error);
	}

	handleShowLoader() {
		store.dispatch(showLoader());
	}

	handleHideLoader() {
		setTimeout(() => {
			store.dispatch(hideLoader());
		}, 3000);
	}

	handle422Error(data, setErrors) {
		const serverErrors = data.error;

		if (!isEmpty(serverErrors) && setErrors) {
			setErrors(serverErrors);
			const val = serverErrors[Object.keys(serverErrors)[0]];

			console.log('handle422Error val', val);

			return val;
		}

		return null;
	}
}

export const API = new ApiRequestClass();
